import styled from "@emotion/styled"
import { PropsWithChildren } from "react"

const Button = styled.button`
    background-color: #383838;
    padding: 5rem 10rem;
    font-size: 16rem;
    font-family: monospace;
    color: #fff;
`

type BaseButtonProps = ExtractStyledProps<typeof Button>

function BaseButton(props: BaseButtonProps) {
    const { children, ...rest } = props

    return <Button {...rest}>{children}</Button>
}

export default BaseButton
